import { Link } from 'react-router-dom';

interface Props {
    href: string;
}

export const ViewDetails = ({ href }: Props) => {
    return (
        <Link
            to={href}
            style={{ display: 'flex', float: 'right' }}
            className='btn btn-sm mr-1 mb-1 btn-light pull-right'
        >
            <i
                className='mdi mdi-eye'
                style={{
                    marginRight: '2px',
                }}
            ></i>{' '}
            Editar
        </Link>
    );
};
